"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpErrorBoundary = exports.appRedirectMap = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var i18n_1 = require("../../../i18n");
var styled_components_1 = require("styled-components");
var baseTheme_1 = __importDefault(require("@greatmindsorg/atomic-ui-lib-lts/dist/themes/baseTheme"));
var GlobalHttpErrorPage_component_1 = require("@greatmindsorg/atomic-ui-lib-lts/dist/components/organisms/GlobalHttpErrorPage/GlobalHttpErrorPage.component");
var api_1 = require("../../../api");
(0, i18n_1.initI18n)();
/**
 * DpErrorBoundary
 *
 * Catches all unhandled errors, both rendering errors and promise unhandled rejections.
 * Currently doesn't catch errors triggered on event handlers.
 *
 */
exports.appRedirectMap = new Map([
    ['admin-app', '/assessments/admin'],
    ['teacher-app', '/assessments/teacher'],
    ['student-app', '/assessments/student'],
]);
var DpErrorBoundary = /** @class */ (function (_super) {
    __extends(DpErrorBoundary, _super);
    function DpErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.handleUnexpectedPromiseError = function (event) {
            if (_this.is401(event) && !_this.isLocalhost()) {
                if (_this.props.isLti) {
                    window.location.reload();
                }
                else {
                    window.location.href = '/';
                }
            }
            else if (!_this.isUnhandledApiError(event) && !_this.isExpectedLearnosityError(event)) {
                _this.setState({
                    hasError: true,
                    isPromiseError: true,
                    error: event.reason,
                });
            }
        };
        _this.renderErrorAlert = function () {
            var actions = [
                {
                    actionMsg: 'Go To Home',
                    variant: 'primary',
                    actionCallback: function () {
                        return window.open("".concat(window.location.origin).concat(exports.appRedirectMap.get(_this.props.appName)), '_self');
                    },
                },
                {
                    actionMsg: 'Help Center',
                    variant: 'primary',
                    actionCallback: function () { return window.open(api_1.HELP_CENTER); },
                },
            ];
            var rootElem = document.getElementById('root');
            if (rootElem !== null) {
                var navToggle = rootElem.getElementsByClassName('navigation-toggle');
                if (navToggle.length) {
                    // eslint-disable-next-line
                    navToggle[0].style.display = 'none';
                }
            }
            return ((0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: baseTheme_1.default, children: (0, jsx_runtime_1.jsx)(GlobalHttpErrorPage_component_1.GlobalHttpErrorPage, { customErrorMessage: "An unexpected error has occurred!", actions: actions, showErrorCode: false }) }));
        };
        _this.state = {
            hasError: false,
            isPromiseError: false,
        };
        return _this;
    }
    DpErrorBoundary.getDerivedStateFromError = function (error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            error: error.message,
            isPromiseError: false,
        };
    };
    DpErrorBoundary.prototype.componentDidMount = function () {
        window.addEventListener('unhandledrejection', this.handleUnexpectedPromiseError);
    };
    DpErrorBoundary.prototype.is401 = function (_a) {
        var reason = _a.reason;
        return reason && reason.response && reason.response.status === 401;
    };
    DpErrorBoundary.prototype.isUnhandledApiError = function (_a) {
        var reason = _a.reason;
        return reason && (reason.status || (reason.response && reason.response.status));
    };
    // Learnosity errors from the view as student or when taking the assessment
    DpErrorBoundary.prototype.isExpectedLearnosityError = function (event) {
        var isSilentRejection = event.reason === undefined;
        var isLearnosityContext = !!document.querySelector('[data-testid="wizard-preview-modal"]') ||
            !!document.querySelector('.player-container');
        var currentURL = window.location.href;
        var isLearnosityURL = currentURL.includes('/teacher/library?curriculaCode') ||
            currentURL.includes('/teacher/library/assessment') ||
            currentURL.includes('/teacher/my_library?curriculaCode') ||
            currentURL.includes('/teacher/home?curriculaCode');
        return isSilentRejection && (isLearnosityContext || isLearnosityURL);
    };
    DpErrorBoundary.prototype.isLocalhost = function () {
        return Boolean(window.location.hostname === 'localhost' ||
            window.location.hostname === '[::1]' || // [::1] is the IPv6 localhost address.
            window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)); // 127.0.0.1/8 is considered localhost for IPv4.
    };
    DpErrorBoundary.prototype.render = function () {
        var _a = this.state, hasError = _a.hasError, isPromiseError = _a.isPromiseError;
        var children = this.props.children;
        // only render children if it was an unhandled promise error to avoid infinite loop
        var renderChildren = !(hasError || isPromiseError);
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [hasError && this.renderErrorAlert(), renderChildren && children] }));
    };
    return DpErrorBoundary;
}(react_1.Component));
exports.DpErrorBoundary = DpErrorBoundary;
